import React, { PureComponent } from 'react';
import { Breadcrumbs, BreadcrumbItem, Button } from '@cimpress/react-components';

export default class BreadcrumbDemo extends PureComponent {
  render() {
    return (
      <Breadcrumbs>
        <BreadcrumbItem>
          <Button variant="anchor">Home</Button>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Button variant="anchor" href="/breadcrumbs">
            Library
          </Button>
        </BreadcrumbItem>
        <BreadcrumbItem active>Data</BreadcrumbItem>
      </Breadcrumbs>
    );
  }
}
